import { render } from "./FormFields.vue?vue&type=template&id=63b54211&scoped=true"
import script from "./FormFields.vue?vue&type=script&lang=js"
export * from "./FormFields.vue?vue&type=script&lang=js"

import "./FormFields.vue?vue&type=style&index=0&id=63b54211&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b54211"]])

export default __exports__